module.exports = __webpack_public_path__ + "static/Fellix-Regular-37c12820208d0f35197d2737175feeaf.eot";